import { TouchEvent, useState } from "react";

interface UseSwipeInput {
	onSwipedLeft: () => void;
	onSwipedRight: () => void;
}

interface UseSwipeOutput {
	onTouchStart: (e: TouchEvent) => void;
	onTouchMove: (e: TouchEvent) => void;
	onTouchEnd: () => void;
}

export default (input: UseSwipeInput): UseSwipeOutput => {
	const [touchStart, setTouchStart] = useState(0);
	const [touchEnd, setTouchEnd] = useState(0);

	const minSwipeDistance = 80;

	function onTouchStart(e: TouchEvent) {
		// reset touch end
		setTouchEnd(0);
		setTouchStart(e.targetTouches[0].clientX);
	}

	function onTouchMove(e: TouchEvent) {
		setTouchEnd(e.targetTouches[0].clientX);
	}

	function onTouchEnd() {
		if (!touchStart || !touchEnd) return;
		const distance = touchStart - touchEnd;
		const isLeftSwipe = distance > minSwipeDistance;
		const isRightSwipe = distance < -minSwipeDistance;
		if (isLeftSwipe) {
			input.onSwipedLeft();
		}
		if (isRightSwipe) {
			input.onSwipedRight();
		}
	}

	return {
		onTouchStart,
		onTouchMove,
		onTouchEnd,
	};
};
